<!-- eslint-disable no-useless-escape -->
<!-- eslint-disable no-useless-escape -->
<template>
  <div class="ai-chat-view">
    <NavBar />
    <!-- Chat Container -->
    <div class="chat-container">
      <!-- Header -->
      <div class="chat-header">
        <div class="header-content">
          <div class="logo-section">
            <div class="ai-avatar">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="title-section">
              <h1 style="color:azure">CHBS NetSuite AI</h1>
              <p class="status">
                <span class="status-dot"></span>
                En línea
              </p>
            </div>
          </div>
          <button class="clear-button" @click="clearChat" v-if="messages.length > 0">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Nueva conversación</span>
          </button>
        </div>
      </div>

      <!-- Messages Area -->
      <div class="messages-container" ref="messagesContainer">
        <div class="messages-wrapper">
          <!-- Welcome Message -->
          <div class="message-group bot-message" v-if="messages.length === 0">
            <div class="message-avatar">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="message-content">
              <div class="message-bubble">
                <h2 class="welcome-title">¡Hola! Soy tu asistente virtual de ChillByte</h2>
                <p>Estoy aquí para ayudarte con información sobre reportes de NetSuite. ¿En qué puedo ayudarte hoy?</p>
                <!-- <p>Estoy aquí para ayudarte con información sobre NetSuite, implementaciones y soluciones empresariales. ¿En qué puedo ayudarte hoy?</p> -->
                <div class="suggestion-chips">
                  <button class="chip" @click="sendSuggestion('¿Qué reportes me dan visión directiva?')">
                    ¿Qué reportes me dan visión directiva?
                  </button>
                  <!-- <button class="chip" @click="sendSuggestion('¿Qué servicios ofrecen?')">
                    ¿Qué servicios ofrecen?
                  </button>
                  <button class="chip" @click="sendSuggestion('Información sobre NetSuite')">
                    Información sobre NetSuite
                  </button>
                  <button class="chip" @click="sendSuggestion('¿Cómo puedo contactarlos?')">
                    ¿Cómo puedo contactarlos?
                  </button>
                  <button class="chip" @click="sendSuggestion('Precios y planes')">
                    Precios y planes
                  </button> -->
                </div>
              </div>
            </div>
          </div>

          <!-- Chat Messages -->
          <div 
            v-for="(message, index) in messages" 
            :key="index"
            :class="['message-group', message.isUser ? 'user-message' : 'bot-message']"
          >
            <div class="message-avatar" v-if="!message.isUser">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="message-content">
              <div class="message-bubble">
                <p v-html="formatMessage(message.text)"></p>
              </div>
              <span class="message-time">{{ message.time }}</span>
            </div>
          </div>

          <!-- Typing Indicator -->
          <div class="message-group bot-message" v-if="isTyping">
            <div class="message-avatar">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="message-content">
              <div class="message-bubble typing-indicator">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Input Area -->
      <div class="input-container">
        <div class="input-wrapper">
          <textarea
            v-model="userInput"
            @keydown.enter.exact.prevent="sendMessage"
            @input="adjustTextareaHeight"
            placeholder="Escribe tu mensaje aquí..."
            rows="1"
            ref="textarea"
            :disabled="isTyping"
          ></textarea>
          <button 
            class="send-button" 
            @click="sendMessage"
            :disabled="!userInput.trim() || isTyping"
          >
            <svg v-if="!isTyping" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div v-else class="spinner"></div>
          </button>
        </div>
        <p class="input-hint">Presiona Enter para enviar, Shift + Enter para nueva línea</p>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import NavBar from '@/components/Template/NavBar.vue';
import Footer from '@/components/Template/Footer.vue';
export default {
  name: 'AIChat',
  components: {
    NavBar,
    Footer
  },
  data() {
    return {
      messages: [],
      userInput: '',
      isTyping: false,
      sessionId: null,
      projectId: 'chill-byte-ai',
      agentId: process.env.AGENT_ID,
      apiBaseUrl: process.env.VUE_APP_API_URL || 'http://localhost:3001'
    }
  },
  metaInfo: {
    title: 'Asistente NetSuite IA - Chill Byte Solutions',
    meta: [
      {
        name: 'description',
        content: 'Chatea con nuestro agente IA para NetSuite. Obtén respuestas sobre NetSuite y nuestros servicios 24/7.'
      }
    ]
  },
  mounted() {
    this.sessionId = this.generateSessionId();
    this.$refs.textarea.focus();
  },
  methods: {
    generateSessionId() {
      return 'session-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    },
    
    async sendMessage() {
      if (!this.userInput.trim() || this.isTyping) return;

      const messageText = this.userInput.trim();
      this.userInput = '';
      this.adjustTextareaHeight();

      // Add user message
      this.messages.push({
        text: messageText,
        isUser: true,
        time: this.getCurrentTime()
      });

      this.scrollToBottom();
      this.isTyping = true;

      try {
        // Call Dialogflow API
        const response = await this.callDialogflowAPI(messageText);
        
        // Simulate typing delay for better UX
        await new Promise(resolve => setTimeout(resolve, 500));
        
        this.isTyping = false;
        
        // Add bot response
        this.messages.push({
          text: response,
          isUser: false,
          time: this.getCurrentTime()
        });

        this.scrollToBottom();
      } catch (error) {
        console.error('Error calling Dialogflow:', error);
        this.isTyping = false;
        
        this.messages.push({
          text: 'Lo siento, hubo un error al procesar tu mensaje. Por favor, intenta de nuevo o contacta con nuestro equipo de soporte.',
          isUser: false,
          time: this.getCurrentTime()
        });
        
        this.scrollToBottom();
      }
    },

    async callDialogflowAPI(message) {
      try {
        console.log('📤 Calling API:', this.apiBaseUrl);
        
        const response = await fetch(`${this.apiBaseUrl}/api/chat`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            message: message,
            sessionId: this.sessionId
          })
        });

        console.log('📥 Response status:', response.status);

        if (!response.ok) {
          const errorText = await response.text();
          console.error('❌ API Error:', errorText);
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('📦 Response data:', data);
        
        // Check if response exists
        if (!data.response) {
          console.warn('⚠️ No response text in data:', data);
          return data.error || 'Lo siento, no recibí una respuesta válida del servidor.';
        }
        
        // Log for debugging
        if (data.source) {
          console.log(`✅ Response source: ${data.source}`);
        }
        
        return data.response;
      } catch (error) {
        console.error('❌ Error calling backend API:', error);
        
        // Check if it's a network error
        if (error.message.includes('fetch') || error.name === 'TypeError') {
          return `No se puede conectar con el servidor. Por favor, verifica la conexión. (${this.apiBaseUrl})`;
        }
        
        throw error;
      }
    },

    sendSuggestion(text) {
      this.userInput = text;
      this.sendMessage();
    },

    clearChat() {
      this.messages = [];
      this.sessionId = this.generateSessionId();
      this.$refs.textarea.focus();
    },

    adjustTextareaHeight() {
      this.$nextTick(() => {
        const textarea = this.$refs.textarea;
        textarea.style.height = 'auto';
        textarea.style.height = Math.min(textarea.scrollHeight, 120) + 'px';
      });
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messagesContainer;
        container.scrollTop = container.scrollHeight;
      });
    },

    getCurrentTime() {
      const now = new Date();
      return now.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    },

    formatMessage(text) {
      if (!text) return '';
      
      // Escape HTML to prevent XSS attacks
      let formatted = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
      
      // Convert markdown-style formatting (order matters!)
      // Bold: **text** or __text__ (do these first)
      formatted = formatted.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
      formatted = formatted.replace(/__(.+?)__/g, '<strong>$1</strong>');
      
      // Italic: *text* or _text_ (after bold so we don't match ** or __)
      formatted = formatted.replace(/\*([^*]+?)\*/g, '<em>$1</em>');
      formatted = formatted.replace(/_([^_]+?)_/g, '<em>$1</em>');
      
      // Code: `code`
      formatted = formatted.replace(/`(.+?)`/g, '<code>$1</code>');
      
      // Bullet points: • or - at start of line
      formatted = formatted.replace(/^[•\\-]\s+(.+)$/gm, '<span class="bullet-point">• $1</span>');
      
      // Numbered lists: 1. or 1) at start of line
      formatted = formatted.replace(/^\d+[\\.)]\s+(.+)$/gm, '<span class="numbered-point">$1</span>');
      
      // Links: [text](url)
      formatted = formatted.replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
      
      // Convert line breaks to HTML
      formatted = formatted.replace(/\n/g, '<br>');
      
      return formatted;
    }
  }
}
</script>

<style scoped lang="scss">
.ai-chat-view {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8eef7 100%);
  display: flex;
  flex-direction: column;
}

.chat-container {
  width: calc(100% - 40px);
  max-width: 900px;
  height: calc(100vh - 150px);
  max-height: 800px;
  background: white;
  border-radius: 5px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: fadeIn 0.3s ease-out;
  margin: 30px auto;
  flex-shrink: 0;
}

// Header
.chat-header {
  background: linear-gradient(135deg, #0a2463 0%, #1e3a8a 50%, #3e92cc 100%);
  color: white;
  padding: 20px 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .logo-section {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .ai-avatar {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(10px);

    svg {
      width: 28px;
      height: 28px;
      color: white;
    }
  }

  .title-section {
    h1 {
      font-size: 1.5rem;
      font-weight: 700;
      margin: 0 0 4px 0;
    }

    .status {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 0.85rem;
      opacity: 0.9;
      margin: 0;

      .status-dot {
        width: 8px;
        height: 8px;
        background: #4ade80;
        border-radius: 50%;
        animation: pulse 2s ease-in-out infinite;
      }
    }
  }

  .clear-button {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    padding: 10px 18px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 0.9rem;
    font-weight: 500;
    transition: all 0.2s ease;
    backdrop-filter: blur(10px);

    &:hover {
      background: rgba(255, 255, 255, 0.25);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }

    svg {
      width: 18px;
      height: 18px;
    }
  }
}

// Messages Area
.messages-container {
  flex: 1;
  overflow-y: auto;
  padding: 30px;
  background: #fafbfc;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;

    &:hover {
      background: #94a3b8;
    }
  }
}

.messages-wrapper {
  max-width: 800px;
  margin: 0 auto;
}

.message-group {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  animation: slideUp 0.3s ease-out;

  &.user-message {
    flex-direction: row-reverse;

    .message-content {
      align-items: flex-end;
    }

    .message-bubble {
      background:#3f84e5;
      color: white;
      border-radius: 18px 18px 4px 18px;
    }

    .message-time {
      text-align: right;
    }
  }

  &.bot-message {
    .message-bubble {
      background: white;
      color: #1e293b;
      border-radius: 18px 18px 18px 4px;
      border: 1px solid #e2e8f0;
    }
  }
}

.message-avatar {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
    color: white;
  }
}

.message-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 75%;
}

.message-bubble {
  padding: 14px 18px;
  line-height: 1.6;
  font-size: 0.95rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  p {
    margin: 0;
  }

  .welcome-title {
    font-size: 1.25rem;
    font-weight: 700;
    margin: 0 0 12px 0;
    color: #1e293b;
  }

  // Text formatting styles
  strong {
    font-weight: 700;
  }

  em {
    font-style: italic;
  }

  code {
    background: rgba(0, 0, 0, 0.08);
    padding: 2px 6px;
    border-radius: 4px;
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.9em;
  }

  a {
    color: #667eea;
    text-decoration: underline;
    transition: color 0.2s ease;

    &:hover {
      color: #764ba2;
    }
  }

  .bullet-point {
    display: block;
    margin: 4px 0;
    padding-left: 4px;
  }

  .numbered-point {
    display: block;
    margin: 4px 0;
    padding-left: 4px;
    
    &::before {
      content: counter(list-item) '. ';
      counter-increment: list-item;
    }
  }
}

// For user messages, adjust link color
.user-message .message-bubble {
  a {
    color: #fff;
    font-weight: 600;
    
    &:hover {
      color: #f0f0f0;
    }
  }

  code {
    background: rgba(255, 255, 255, 0.2);
  }
}

.message-time {
  font-size: 0.75rem;
  color: #94a3b8;
  padding: 0 4px;
}

// Suggestion Chips
.suggestion-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;

  .chip {
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    color: #475569;
    padding: 10px 16px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
      background: #667eea;
      color: white;
      border-color: #667eea;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

// Typing Indicator
.typing-indicator {
  display: flex;
  gap: 6px;
  padding: 18px !important;

  span {
    width: 8px;
    height: 8px;
    background: #94a3b8;
    border-radius: 50%;
    animation: typing 1.4s ease-in-out infinite;

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
}

// Input Area
.input-container {
  background: white;
  border-top: 1px solid #e2e8f0;
  padding: 20px 30px;
}

.input-wrapper {
  display: flex;
  gap: 12px;
  align-items: flex-end;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  padding: 8px 8px 8px 16px;
  transition: all 0.2s ease;

  &:focus-within {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  }

  textarea {
    flex: 1;
    border: none;
    background: transparent;
    resize: none;
    font-size: 0.95rem;
    color: #1e293b;
    font-family: inherit;
    line-height: 1.5;
    padding: 8px 0;
    min-height: 24px;
    max-height: 120px;

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: #94a3b8;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .send-button {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.2s ease;

    svg {
      color: white;
    }

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .spinner {
      width: 18px;
      height: 18px;
      border: 2px solid rgba(255, 255, 255, 0.3);
      border-top-color: white;
      border-radius: 50%;
      animation: spin 0.6s linear infinite;
    }
  }
}

.input-hint {
  margin: 8px 0 0 0;
  font-size: 0.75rem;
  color: #94a3b8;
  text-align: center;
}

// Animations
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.1);
  }
}

@keyframes typing {
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-10px);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

// Responsive Design
@media (max-width: 768px) {
  .ai-chat-view {
    padding: 0;
  }

  .chat-container {
    width: 100%;
    height: calc(100vh - 120px);
    max-height: none;
    border-radius: 0;
    margin: 0;
  }

  .chat-header {
    padding: 16px 20px;

    .clear-button {
      padding: 8px 12px;
      font-size: 0.85rem;

      span {
        display: none;
      }
    }

    .title-section h1 {
      font-size: 1.25rem;
    }
  }

  .messages-container {
    padding: 20px 16px;
  }

  .message-content {
    max-width: 85%;
  }

  .input-container {
    padding: 16px 20px;
  }
}

@media (max-width: 480px) {
  .chat-header {
    .ai-avatar {
      width: 40px;
      height: 40px;

      svg {
        width: 24px;
        height: 24px;
      }
    }

    .title-section h1 {
      font-size: 1.1rem;
    }

    .clear-button {
      width: 40px;
      padding: 8px;

      svg {
        margin: 0;
      }

      span {
        display: none;
      }
    }
  }

  .message-avatar {
    width: 32px;
    height: 32px;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  .suggestion-chips {
    .chip {
      font-size: 0.8rem;
      padding: 8px 14px;
    }
  }
}
</style>
